import { createReducer } from '@reduxjs/toolkit'
import {
  setPage,
  setPageSize,
  setTotal,
  setData,
  setFilters,
  setMode,
  setOrder,
  resetFilters,
} from './action'

import {
  TData,
  TFilters,
  TSort,
  TViewMode,
} from 'pages/AiCalls/helpers/constant'

type TState = {
  page: number
  pageSize: number
  total: number
  mode: TViewMode
  sortData: TSort
  filters: TFilters
  data: TData
}

export const initialFilters: TFilters = {
  status: '',
  keyword: '',
  assignee_crm_user_id: '',
  from: '',
  to: '',
  date: '',
}

const initialState: TState = {
  page: 1,
  pageSize: 40,
  total: 0,
  mode: 'daily',
  sortData: {
    sort_by: '',
    sort: '',
  },
  filters: initialFilters,
  data: [],
}

export const AiCallsReducer = createReducer(initialState, builder => {
  builder
    .addCase(setPage, (state, action) => {
      state.page = action.payload
    })
    .addCase(setPageSize, (state, action) => {
      state.pageSize = action.payload
    })
    .addCase(setTotal, (state, action) => {
      state.total = action.payload
    })
    .addCase(setData, (state, action) => {
      state.data = action.payload
    })
    .addCase(setFilters, (state, action) => {
      state.filters = {
        ...state.filters,
        ...action.payload,
      }
    })
    .addCase(setMode, (state, action) => {
      state.mode = action.payload
    })
    .addCase(setOrder, (state, action) => {
      state.sortData = action.payload
    })
    .addCase(resetFilters, state => {
      state.filters = initialFilters
    })
})

export default AiCallsReducer
